// extracted by mini-css-extract-plugin
export default {"control-buttons":"styles_control-buttons__+ifke"};